import getAPI from './getAPI.js'

export default async function getAdminTaskInstances() {
    const data = await getAPI('admin/taskinstances');
    return data;
}
